export class Config {
    static functionUrl = "-wxsb3qhria-ew.a.run.app";//"http://127.0.0.1:5001/ecoconduite-ab3c1/europe-west1/";
}